(function () {
  'use strict';
  function init() {
    var modal = document.querySelector('[data-zr-bundle-modal]');
    if (!modal || modal.dataset.zrPopupReady) return;
    modal.dataset.zrPopupReady = 'true';
    var dialog = modal.querySelector('[role="dialog"]');
    var key = 'zrBundlePopupDismissedAt';
    var previousFocus, background = [], timer, leaseTimer, checkQueued = false;
    var last = 0, autoPending = false, openedAutomatically = false, blocked = false, openingUntil = 0;
    var delay = Math.max(0, parseInt(modal.dataset.delay, 10) || 0);
    try { last = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
    function eligible() { return Date.now() - last > (parseInt(modal.dataset.days, 10) || 7) * 86400000; }
    function remember() {
      last = Date.now(); autoPending = false;
      try { localStorage.setItem(key, String(last)); } catch (e) {}
    }
    function visible(el) {
      if (el.closest('[hidden],dialog:not([open]),.MuiModal-hidden')) return false;
      var style = getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse' && el.getClientRects().length > 0;
    }
    function otherOverlay() {
      return Array.prototype.some.call(document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"],.drawer--is-open,.modal--is-active,.MuiModal-root:not(.MuiModal-hidden)'),function (el) {
        // Do not count the bundle's own dialog or any of its descendants.
        return !modal.contains(el) && visible(el);
      });
    }
    function close(options) {
      options = options || {};
      if (modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('zr-bundle-modal-open');
      // Release only locks this popup acquired; preserve pre-existing inert areas.
      background.forEach(function (el) { el.inert = false; });
      background = [];
      if (options.dismiss !== false) remember();
      if (options.restoreFocus !== false && previousFocus && previousFocus.isConnected && !previousFocus.closest('[hidden],[inert]') && !otherOverlay()) previousFocus.focus({preventScroll:true});
      openedAutomatically = false;
    }
    function interrupt() {
      if (!modal.hidden && openedAutomatically && eligible()) autoPending = true;
      close({dismiss:false,restoreFocus:false});
    }
    function scheduleAuto() {
      window.clearTimeout(timer);
      if (!autoPending || !eligible() || blocked || document.hidden || /\/cart\/?$/.test(location.pathname)) return;
      timer = window.setTimeout(function () {
        timer = null;
        if (!autoPending || !eligible()) return;
        checkOverlays();
        if (blocked || document.hidden || /\/cart\/?$/.test(location.pathname)) return;
        open(true);
      }, delay);
    }
    function checkOverlays() {
      checkQueued = false;
      var foreign = otherOverlay();
      // Once the new popup is mounted, follow its real visibility rather than
      // retaining the short reservation after the customer closes it.
      if (foreign) openingUntil = 0;
      var next = Date.now() < openingUntil || foreign;
      var changed = next !== blocked;
      blocked = next;
      if (document.body.classList.contains('zr-bundle-blocked') !== blocked) document.body.classList.toggle('zr-bundle-blocked',blocked);
      if (blocked) {
        window.clearTimeout(timer); timer = null;
        interrupt();
      } else if (changed) scheduleAuto();
    }
    function queueCheck() {
      if (checkQueued) return;
      checkQueued = true; requestAnimationFrame(checkOverlays);
    }
    function openingOverlay() {
      // Release inert and the focus trap BEFORE the app mounts/focuses its popup.
      openingUntil = Date.now() + 1500;
      checkOverlays();
      window.clearTimeout(leaseTimer);
      leaseTimer = window.setTimeout(checkOverlays,1505);
    }
    function open(automatic) {
      checkOverlays();
      if (blocked || !modal.hidden) return;
      window.clearTimeout(timer); timer = null;
      autoPending = false; openedAutomatically = automatic === true;
      previousFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('zr-bundle-modal-open');
      var node = modal;
      while (node.parentElement && node !== document.body) {
        Array.prototype.forEach.call(node.parentElement.children, function (sibling) {
          if (sibling !== node && !sibling.inert && !/^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) {
            sibling.inert = true; background.push(sibling);
          }
        });
        node = node.parentElement;
      }
      // Put keyboard focus on the visible close control, not behind the dialog.
      var closeButton = dialog.querySelector('button[data-zr-bundle-close]');
      (closeButton || dialog).focus({preventScroll:true});
    }
    modal.querySelectorAll('[data-zr-bundle-close]').forEach(function (el) { el.addEventListener('click',function () { close(); }); });
    document.addEventListener('click',function (event) {
      if (event.target.closest && event.target.closest('[data-zr-bundle-open]')) { event.preventDefault(); open(false); }
    });
    var cta = modal.querySelector('.zr-bundle-modal__cta');
    if (cta) cta.addEventListener('click',remember);
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (otherOverlay()) { interrupt(); return; }
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]'), function (el) { return visible(el); });
      var first = focusable[0], lastButton = focusable[focusable.length - 1];
      if (!first) { e.preventDefault(); dialog.focus(); return; }
      if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); lastButton.focus(); }
      else if (!e.shiftKey && (document.activeElement === lastButton || document.activeElement === dialog)) { e.preventDefault(); first.focus(); }
    });
    ['wishlist-hero-wishlist-show','wishlist-hero-open-popup','wishlist-hero-open-login-popup','wishlist-hero-open-share-popup','zr:overlay-opening'].forEach(function (name) {
      document.addEventListener(name,openingOverlay,true);
    });
    // Fallback for a popup opened by an app without a documented open event.
    new MutationObserver(queueCheck).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open','hidden','class','style','aria-modal','aria-hidden']});
    document.addEventListener('close',queueCheck,true);
    document.addEventListener('transitionend',queueCheck,true);
    document.addEventListener('animationend',queueCheck,true);
    document.addEventListener('visibilitychange',function () { if (document.hidden) window.clearTimeout(timer); else { checkOverlays(); scheduleAuto(); } });
    autoPending = eligible();
    checkOverlays(); scheduleAuto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
}());
